export const ATTR_SEARCH = 'ATTR_SEARCH';
export const SET_PAGE = 'SET_PAGE';